
<script>
import { mapGetters } from 'vuex'
/**
 * Nav-bar Component
 */
export default {
  computed: {
    ...mapGetters({
      avatar: 'user/avatar',
      name: 'user/name'
    })
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    logout() {
      this.$store.dispatch('user/logout').then(() => {
        window.location.href = '/'
      })
    }
  }
}
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <!--          <a href="/" class="logo logo-dark">-->
          <!--            <span class="logo-sm">-->
          <!--              <img src="/images/logo.svg" alt height="22">-->
          <!--            </span>-->
          <!--            <span class="logo-lg">-->
          <!--              <img src="/images/logo-dark.png" alt height="17">-->
          <!--            </span>-->
          <!--          </a>-->

          <router-link to="/home" class="logo logo-light">
            <span class="logo-sm">
              <img src="/images/logo-light.svg" alt height="22">
            </span>
            <span class="logo-lg">
              <img src="/images/logo-light.png" alt height="19">
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars" />
        </button>
      </div>

      <div class="d-flex">
        <!--        <b-dropdown-->
        <!--          right-->
        <!--          menu-class="dropdown-menu-lg p-0"-->
        <!--          toggle-class="header-item noti-icon"-->
        <!--          variant="black"-->
        <!--        >-->
        <!--          <template v-slot:button-content>-->
        <!--            <i class="bx bx-bell bx-tada"></i>-->
        <!--            <span class="badge badge-danger badge-pill">3</span>-->
        <!--          </template>-->

        <!--          <div class="p-3">-->
        <!--            <div class="row align-items-center">-->
        <!--              <div class="col">-->
        <!--                <h6 class="m-0">Notifications</h6>-->
        <!--              </div>-->
        <!--              <div class="col-auto">-->
        <!--                <a href="#!" class="small">View All</a>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <simplebar style="max-height: 230px;">-->
        <!--            <a href class="text-reset notification-item">-->
        <!--              <div class="media">-->
        <!--                <div class="avatar-xs mr-3">-->
        <!--                  <span class="avatar-title bg-primary rounded-circle font-size-16">-->
        <!--                    <i class="bx bx-cart"></i>-->
        <!--                  </span>-->
        <!--                </div>-->
        <!--                <div class="media-body">-->
        <!--                  <h6 class="mt-0 mb-1">Your order is placed</h6>-->
        <!--                  <div class="font-size-12 text-muted">-->
        <!--                    <p class="mb-1">If several languages coalesce the grammar</p>-->
        <!--                    <p class="mb-0">-->
        <!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
        <!--                    </p>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </a>-->
        <!--            <a href class="text-reset notification-item">-->
        <!--              <div class="media">-->
        <!--                <img-->
        <!--                  src="/images/users/avatar-3.jpg"-->
        <!--                  class="mr-3 rounded-circle avatar-xs"-->
        <!--                  alt="user-pic"-->
        <!--                />-->
        <!--                <div class="media-body">-->
        <!--                  <h6 class="mt-0 mb-1">James Lemire</h6>-->
        <!--                  <div class="font-size-12 text-muted">-->
        <!--                    <p class="mb-1">It will seem like simplified English.</p>-->
        <!--                    <p class="mb-0">-->
        <!--                      <i class="mdi mdi-clock-outline"></i> 1 hours ago-->
        <!--                    </p>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </a>-->
        <!--            <a href class="text-reset notification-item">-->
        <!--              <div class="media">-->
        <!--                <div class="avatar-xs mr-3">-->
        <!--                  <span class="avatar-title bg-success rounded-circle font-size-16">-->
        <!--                    <i class="bx bx-badge-check"></i>-->
        <!--                  </span>-->
        <!--                </div>-->
        <!--                <div class="media-body">-->
        <!--                  <h6 class="mt-0 mb-1">Your item is shipped</h6>-->
        <!--                  <div class="font-size-12 text-muted">-->
        <!--                    <p class="mb-1">If several languages coalesce the grammar</p>-->
        <!--                    <p class="mb-0">-->
        <!--                      <i class="mdi mdi-clock-outline"></i> 3 min ago-->
        <!--                    </p>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </a>-->

        <!--            <a href class="text-reset notification-item">-->
        <!--              <div class="media">-->
        <!--                <img-->
        <!--                  src="/images/users/avatar-4.jpg"-->
        <!--                  class="mr-3 rounded-circle avatar-xs"-->
        <!--                  alt="user-pic"-->
        <!--                />-->
        <!--                <div class="media-body">-->
        <!--                  <h6 class="mt-0 mb-1">Salena Layfield</h6>-->
        <!--                  <div class="font-size-12 text-muted">-->
        <!--                    <p class="mb-1">As a skeptical Cambridge friend of mine occidental.</p>-->
        <!--                    <p class="mb-0">-->
        <!--                      <i class="mdi mdi-clock-outline"></i> 1 hours ago-->
        <!--                    </p>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </a>-->
        <!--          </simplebar>-->
        <!--          <div class="p-2 border-top">-->
        <!--            <a class="btn btn-sm btn-light btn-block text-center" href="javascript:void(0)">-->
        <!--              <i class="mdi mdi-arrow-down-circle mr-1"></i> Load More..-->
        <!--            </a>-->
        <!--          </div>-->
        <!--        </b-dropdown>-->

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              :src="avatar"
            >
            <span class="d-none d-xl-inline-block ml-1">{{ name }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </template>
          <!-- item-->
          <router-link class="dropdown-item" to="/profile">
            <i class="bx bx-user font-size-16 align-middle mr-1" /> Профиль
          </router-link>
          <div class="dropdown-divider" />
          <a class="dropdown-item text-danger" href="#" @click.prevent="logout">
            <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger" /> Выйти
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
